import liveReducer from 'live/redux/reducers';
import React, { lazy, Suspense } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import withAsyncReducers from 'shared/containers/withAsyncReducers';
import withContentMenu from 'shared/containers/withContentMenu';

const SelectedGamePopupComponent = lazy(() =>
  import(
    /* webpackChunkName: "selectedGamePopup" */ 'live/containers/SelectedGamePopup/SelectedGamePopup'
  ),
);

const SelectedGamePopupAsyncApp = props => (
  <Suspense fallback={<span />}>
    <SelectedGamePopupComponent {...props} />
  </Suspense>
);

export default compose(
  withAsyncReducers({ live: liveReducer }),
  withRouter,
  withContentMenu,
)(SelectedGamePopupAsyncApp);
